import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from '@magalu/stereo-ui-icons';
import { getPaletteColor, themeGet } from '@magalu/stereo-ui-styles';
export const Ellipsis = styled.div``;
export const Item = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  background: none;
  background-color: ${props => props.selected && getPaletteColor('base')};
  color: ${props => getPaletteColor(props.selected ? 'text' : 'text.dark')(props)};
  padding: 5px;
  min-height: 26px;
  height: 30px;
  min-width: 26px;
  border: 0;
  border-radius: 2px;
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  font-family: ${props => themeGet('fontFamily')(props)};
  text-decoration: none;
`;
export const IconButton = styled.button`
  visibility: ${props => props.disabled ? 'hidden' : 'visible'};
  border: 0;
  background: none;
  display: flex;
`;

const arrowStyle = props => ({
  width: 30,
  height: 30,
  color: props.disabled ? '#ccc' : '#333',
  cursor: props.disabled ? 'not-allowed' : 'pointer'
});

export const Left = styled(ChevronLeft).attrs(arrowStyle)``;
export const Right = styled(ChevronRight).attrs(arrowStyle)``;